import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const CartLoadingState: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <CircularProgress />
    </Box>
  );
};

export default CartLoadingState;